import { createContext, useContext } from 'react';
import type { Logger } from '@wix/fe-essentials/bi';

export const BiContext = createContext<Logger | undefined>(undefined);

export type { Logger };

export function useBi() {
  const context = useContext(BiContext);
  if (context === undefined) {
    throw new Error('useBi must be used within a BiProvider');
  }
  return context;
}
